import React from 'react';
import { TextField, MenuItem } from '@mui/material';

const RenderInputSelectField = ({
  input,
  label,
  data, // [{label,value},...]
  meta: { touched, error },
  ...rest
}) => {
  return (
    <TextField
      select
      label={label}
      variant="standard"
      fullWidth
      error={!!(touched && error)}
      helperText={touched && error ? error : ' '}
      {...input}
      {...rest}
    >
      {data.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default RenderInputSelectField;
